<template>
<drawer :opened.sync="opened" @close="onCloseBtnClick">
  <template #header>{{operatorTip}}</template>

  <template #body>
    <el-form ref="form" :model="model" @keydown.native.enter.prevent="onSaveBtnClick">
      <el-form-item label="是否启用" prop="status">
        <el-switch v-model="model.status" />
      </el-form-item>

      <el-form-item label="规则描述" prop="explanation" :rules="[{
        required: true,
        message: '请输入规则描述'
      }]">
        <el-input v-model="model.explanation" type="textarea" :rows="4" />
      </el-form-item>

      <el-form-item
        label="设置规则(不合格条件)"
        prop="formulaAnalysis"
        :rules="rules"
      >
        <section class="tree-container border rule-main">
          <div class="tree-li" v-for="(el, index) in list" :key="index">
            <div class="rule">
              <!-- 选择规则 -->
              <el-select v-model="el.key" size="small" style="width: 250px;" @change="ruleChange">
                <el-option v-for="item in model.params" :key="item.param" :label="item.name" :value="item.param"></el-option>
              </el-select>
            </div>

            <div class="symbol">
              <!-- 选择符号 -->
              <el-select v-model="el.symbol" size="small" style="width: 100px;" @change="symbolChange">
                <el-option v-for="item in symbolOpt" :key="item.value" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </div>

            <!-- 输入内容 -->
            <div class="rule-cont">
              <el-input v-model="el.value" type="number" size="small" @input="inputChange"/>
              <div style="margin: 0 4px;" v-if="el.symbol === 'between' || el.symbol === 'nobetween'">~</div>
              <el-input  v-if="el.symbol === 'between' || el.symbol === 'nobetween'" v-model="el.value2" type="number" size="small"  @input="inputChange" />
            </div>

            <div class="relation">
              <span v-if="index !== list.length - 1">{{el.relation === '||' ? '或' : '且'}}</span>
            </div>

            <div class="rule-btn">
              <!-- 删除规则 -->
              <span class="del-btn el-icon-delete" @click="delTree(el, index)"></span>
              <!-- 新增规则 -->
              <span v-if="index === list.length - 1" class="add-btn el-icon-plus" @click="addTree(index)"></span>
            </div>
          </div>
          <div class="rule-btn">
            <!-- 新增规则 -->
            <span v-if="list.length === 0" class="add-btn el-icon-plus" @click="addTree(0)"></span>
          </div>
        </section>
      </el-form-item>

      <p style="white-space: normal;word-break: break-all;margin: 0;max-width: 900px;">
        <!-- {{model.formula}} -->
        {{str}}
      </p>
    </el-form>
  </template>

  <template #footer>
    <el-button type="orange" class="btn save-btn" @click="onSaveBtnClick">保存</el-button>
    <a class="cancel-btn btn" @click="onCloseBtnClick">关闭</a>
  </template>
</drawer>
</template>

<script>
import BaseEditor from '../../../BaseEditor'

export default {
  name: 'Editor',
  extends: BaseEditor,
  props: {
  },
  data () {
    let checkTree = (rule, value, callback) => {
      let {list} = this

      if (list.length === 0) {
        return callback(new Error('规则不能为空'))
      }
      let flag = this.list.findIndex(el => {
        if (el.symbol === 'between') {
          return el.value === '' || el.value2 === ''
        }

        return el.value === ''
      })
      setTimeout(() => {
        if (flag === -1) {
          callback()
        } else {
          callback(new Error('请将规则参数填写完整'))
        }
      }, 100)
    }
    return {
      str: '',
      list: [],
      paramsMap: {},
      rules: [{
        required: true,
        validator: checkTree,
        trigger: ['blur', 'change']
      }]
    }
  },
  computed: {
    symbolOpt: () => [
      {
        name: '>=',
        value: '>='
      },
      {
        name: '<=',
        value: '<='
      },
      {
        name: '!=',
        value: '!='
      },
      {
        name: '>',
        value: '>'
      },
      {
        name: '<',
        value: '<'
      },
      {
        name: '=',
        value: '='
      },
      {
        name: '介于',
        value: 'between'
      },
      {
        name: '不介于',
        value: 'nobetween'
      }
    ]
  },
  watch: {
    list (val, oldVal) {
      this.str = ''
      this.recursion(val)
    }
  },
  methods: {
    initModel () {
      return {
        id: null
      }
    },
    ruleChange () {
      this.str = ''
      this.model.formula = ''
      this.recursion(this.list)
    },
    symbolChange () {
      this.str = ''
      this.model.formula = ''
      this.recursion(this.list)
    },
    inputChange () {
      this.str = ''
      this.model.formula = ''
      this.recursion(this.list)
    },
    addTree (index) {
      if (this.list.length === 0) {
        index = -1
      }
      this.list.push({
        id: index + 1,
        relation: '||',
        key: this.model.params[0].param,
        name: '',
        symbol: '>=',
        value: 0,
        value2: 0
      })
    },
    delTree (el) {
      this.list = this.list.filter(item => item.id !== el.id)
    },
    afterGetDetail (model) {
      this.str = ''
      this.paramsMap = model.params.reduce((map, el) => {
        map[el.param] = el
        return map
      }, {})
      this.list = JSON.parse(model.formulaAnalysis)
      this.recursion(this.list)
    },
    save (callback, idKey) {
      let refForm = this.getForm()
      this.inputChange()

      refForm && refForm.validate(flag => {
        let list = Object.assign(this.model, {formulaAnalysis: JSON.stringify(this.list)})

        if (!flag) {
          return
        }

        this.beforeSave()

        this.changeLoadStatus(true)

        this.$api[this.apiKey].save(list, this.operator).then(data => {
          if (data) {
            this.$notify({
              title: '成功',
              message: '保存成功',
              type: 'success',
              position: 'bottom-right'
            })
            this.onSave(data)
            callback && callback(data)
          }
        }).catch(console.error).finally(() => {
          this.changeLoadStatus(false)
        })
      })
    },
    recursion (data) {
      let {paramsMap} = this
      data.forEach((el, index) => {
        if (el.children) {
          this.str = this.str + '('
          this.recursion(el.children)
          this.str = this.str + ')'

          return
        }
        let {key, symbol, value, value2, relation} = el
        let temp = `(${paramsMap[key].name}${symbol}${value})${index === data.length - 1 ? '' : relation}`
        let model = `(${paramsMap[key].param}${symbol}${value})${index === data.length - 1 ? '' : relation}`

        if (symbol === 'between') {
          temp = `(${paramsMap[key].name}>=${value < value2 ? value : value2}&&${paramsMap[key].name}<=${value > value2 ? value : value2})${index === data.length - 1 ? '' : relation}`
          model = `(${paramsMap[key].param}>=${value < value2 ? value : value2}&&${paramsMap[key].param}<=${value > value2 ? value : value2})${index === data.length - 1 ? '' : relation}`
        }

        if (symbol === 'nobetween') {
          temp = `(${paramsMap[key].name}<${value < value2 ? value : value2}||${paramsMap[key].name}>${value > value2 ? value : value2})${index === data.length - 1 ? '' : relation}`
          model = `(${paramsMap[key].param}<${value < value2 ? value : value2}||${paramsMap[key].param}>${value > value2 ? value : value2})${index === data.length - 1 ? '' : relation}`
        }
        this.str = this.str + temp
        this.model.formula = this.model.formula + model
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-form-item {
  margin-bottom: 15px;
}

.el-radio-button {
  /deep/ {
    .el-radio-button__inner {
      padding: 10px;
    }
  }
}

.el-checkbox-group {
  display: block;
  float: left;
  width: 100%;

  /deep/ {
    .el-checkbox-button__inner {
      padding: 10px;
    }
  }
}
.rule-main {
  max-width: 900px;
  height:400px;
  padding: 8px 15px;
  overflow: auto;

  .rule-btn {
    min-width: 80px;
    display: flex;
    flex-direction: row-reverse;
    span {
      display: inline-block;
      width: 30px;
      height: 30px;
      font-size: 20px;
      line-height: 30px;
      border-radius: 5px;
      text-align: center;
      cursor: pointer;
    }

    .add-btn {
      &:hover {
        color: #409EFF;
        background: #eee;
      }
    }

    .del-btn {
      &:hover {
        color: #FF6162;
        background: #eee;
      }
    }
  }
}
.tree-li {
  display: flex;
  justify-content: space-between;
  margin: 5px 0;

  .rule-cont {
    width: 220px;
    display: flex;
  }

  .relation {
    width: 40px;
    font-size: 20px;
    color: #eee;
    font-weight: 550;
    padding: 0 10px;
    border-radius: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/04Config/06QC-Audit-Rule/Editor.vue